// extracted by mini-css-extract-plugin
export var pillWrapper = "_hp-0";
export var showOverflow = "_hp-1";